import React from 'react';

import CrossIcon from 'icons/ic-close.svg';
import TickIcon from 'icons/ic-tick.svg';
import PropTypes from 'prop-types';

export default function ToastUpdateMessage({ message, type }) {
  return (
    <>
      <div
        className={`toast__icon ${type === 'success' ? 'tw-bg-green-500' : 'tw-bg-red-600'}`}
      >
        {type === 'success' ?
          <TickIcon
            className='[&_polygon]:tw-fill-white'
            height={20}
            width={20}
          />
        : <CrossIcon
            className='[&_polygon]:tw-fill-white'
            height={20}
            width={20}
          />
        }
      </div>
      <div className='toast__text'>{message}</div>
    </>
  );
}

ToastUpdateMessage.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};
